// extracted by mini-css-extract-plugin
module.exports = {"arrow":"Arrow-module--arrow--3inyi","up":"Arrow-module--up--UTUDq","right":"Arrow-module--right--2dS2d","down":"Arrow-module--down--3zf58","left":"Arrow-module--left--3f0cZ"};